export default "__VITE_ASSET__BX$8azHb__"